import { Box, IconButton, Stack, styled } from '@mui/material';
import OrderListStatusPanel from 'src/views/uiflow/orders/panels/OrderListStatusPanel';
import MuiDrawer, { DrawerProps } from '@mui/material/Drawer';
import { Close } from 'mdi-material-ui';
import { useNewGridApiRefContext } from 'src/@core/context/newGridRefContext';
import { useEffect, useRef } from 'react';

const Drawer = styled(MuiDrawer)<DrawerProps>(({ theme }) => ({
  width: 600,
  zIndex: theme.zIndex.modal,
  '& .MuiDrawer-paper': {
    border: 0,
    width: '30%',
    minWidth: '300px',
    top: '50px',
    height: '96%',
    zIndex: theme.zIndex.modal,
    boxShadow: theme.shadows[9]
  }
}));

interface StatusHistoryDrawerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
}

const StatusHistoryDrawer = ({ open, setOpen }: StatusHistoryDrawerProps) => {
  const grid = useNewGridApiRefContext();

  const deselectGridRowsRef = useRef(() => {
    console.log('Default deselect function called - grid not initialized yet');
  });

  const closeCallback = () => {
    const deselected: any = deselectGridRowsRef.current();
    if (!deselected) {
      // Deselection failed initially, retrying after delay
      // Try once more after a short delay as fallback
      setTimeout(() => {
        deselectGridRowsRef.current();
      }, 200);
    }
  };

  useEffect(() => {
    deselectGridRowsRef.current = () => {
      const gridInstance = grid.state.gridApiRef?.current?.instance();
      if (gridInstance) {
        try {
          gridInstance.deselectAll();

          // Check if rows are still selected and try alternative method
          if (gridInstance.getSelectedRowKeys()?.length > 0) {
            gridInstance.clearSelection();
          }

          return true; // Successfully deselected
        } catch (error) {
          console.error('Failed to deselect grid rows:', error);
        }
      }

      return false; // Failed to deselect
    };
  }, [grid]);

  return (
    <Drawer
      open={open}
      sx={{
        '.MuiModal-backdrop': { backgroundColor: 'transparent !important', overflowY: 'auto' },
        position: 'relative'
      }}
      onClose={(_e: any, reason: any) => {
        if (reason === 'backdropClick') {
          setOpen(false);
        }
      }}
      anchor="right">
      <Stack
        direction={'row'}
        justifyContent={'flex-end'}
        alignItems={'center'}
        sx={{
          position: 'absolute',
          paddingInline: '15px',
          width: '100%',
          zIndex: 99
        }}>
        <IconButton
          onClick={() => {
            setOpen(false);
            closeCallback();
          }}
          sx={{
            cursor: 'pointer',
            color: 'text.secondary'
          }}>
          <Close />
        </IconButton>
      </Stack>

      <Box sx={{ height: '100%', overflowY: 'auto', paddingBottom: '20px' }}>
        <OrderListStatusPanel isOpen={open} />
      </Box>
    </Drawer>
  );
};

export default StatusHistoryDrawer;
